/* eslint-disable @typescript-eslint/no-var-requires */
const plugin = require('tailwindcss/plugin')
/* eslint-disable @typescript-eslint/no-var-requires */
const colors = require('tailwindcss/colors')

module.exports = {
  purge: {
    layers: ['utilities'],
    content: ['./public/**/*.html', './src/**/*.vue'],
  },
  darkMode: false,
  variants: {
    extend: {
      divideColor: ['group-hover'],
      zIndex: ['responsive', 'hover'],
      position: ['responsive', 'hover'],
      padding: ['responsive', 'last'],
      margin: ['responsive', 'last', 'first'],
      borderWidth: ['responsive', 'last'],
      textAlign: ['last'],
      backgroundColor: ['responsive', 'hover', 'dark', 'dark-hover', 'group-hover', 'odd', 'even'],
      borderColor: ['responsive', 'hover', 'dark', 'dark-hover', 'group-hover'],
      textColor: ['responsive', 'hover', 'dark', 'dark-hover', 'group-hover'],
      translate: ['motion-safe'],
      opacity: ['disabled'],
      cursor: ['disabled'],
    },
  },
  theme: {
    screens: {
      xxs: '460px',
      xs: '750px',
      tablet: '750px',
      sm: '990px',
      md: '1250px',
      desktop: '1250px',
      lg: '1480px',
      xl: '1600px',
    },
    extend: {
      gridTemplateColumns: {
        colums: '1fr 3fr 1fr 3fr 3fr',
        modal: '10fr 2fr',
      },
      gridTemplateRows: {
        content: '1fr auto',
      },
      colors: {
        rose: colors.rose,
        crm: {
          1: '#271460',
          2: '#3DFFC0',
          3: 'rgba(135,135,135,0.07)',
          4: '#f4f2f7',
          5: '#E0DCE8',
          6: '#493B74',
          7: '#FBFAFC',
          8: '#E0DCE8',
          9: '#73649E',
          10: '#27C793',
          11: '#DCD6E7',
          12: '#7A7976',
          13: '#E8E6E6',
          14: '#e0e0e0',
          15: '#696969',
          16: '#73649E',
          17: '#E5E3E3',
          18: '#200a63',
          23: '#F4F5F6',
          24: '#808080',
          19: '#779DE9',
          20: '#A09F9F',
          21: '#3C67B9',
          22: '#737373',
          25: '#F4F5F7',
          26: '#EDD031',
          27: '#DF9630',
          28: '#EDD031',
          blue: '#3C67B9',
          modal: 'rgba(39, 20, 96, 0.8)',
          'builder-loading': 'rgba(255, 255, 255, 0.6)',
          telegram: '#38A6DB',
          facebook: '#3A589E',
          youtube: '#FF0000',
          vk: '#4872A3',
        },
        dark: {
          1: '#293145',
          2: '#232a3b',
          3: '#313a55',
          4: '#1e2533',
          5: '#3f4865',
          6: '#2b3348',
          7: '#181f29',
        },
      },
      textColor: {
        'main-1': '#271460',
        'main-2': '#3DFFC0',
      },

      fontFamily: {
        monrope: ['Manrope'],
      },
      container: {
        center: true,
      },
      spacing: {
        18: '4.5rem',
        30: '123px',
        360: '360px',
        '0-i': '0px !important'
      },
      maxWidth: {
        '1/4': '25%',
        '1/3': '33%',
        '1/2': '50%',
        '3/4': '75%',
        'profile-form': '500px',
        '194p': '194px',
        'terms-container': '960px',
        subs: '800px',
        dashboard: '1440px',
        mobile: '360px',
        modal: '640px',
        'header-app-button': '150px',
        header: '200px',
        siteName: '75px',
        pagination: '1445px',
        'user-offers-condition': '1100px',
        'user-offers-condition-table': '1000px',
        'finances-options-block': '350px',
      },
      maxHeight: {
        '70%': '70%',
        '50%': '50%',
        '74%': '74%',
        '80%': '80%',
        '90%': '90%',
        '10v': '10vh',
        '20v': '20vh',
        '30v': '30vh',
        '40v': '40vh',
        '50v': '50vh',
        '60v': '60vh',
        '70v': '70vh',
        '80v': '80vh',
        '90v': '90vh',
        '100v': '100vh',
        '600p': '600px',
        'photos-block': '100px',
        'device-height': '845px',
        'device-preview': '600px',
        'device-preview-second': '555px',
        'collapsed-device-preview': '459px',
        '72px': '72px'
      },
      minHeight: {
        '30%': '30%',
        '50%': '50%',
        '70%': '70%',
        '74%': '74%',
        '90%': '90%',
        'device-header': '45px',
      },

      width: {
        141: '141px',
        109: '109px',
        92: '92px',
        93: '93px',
        80: '80px',
        77: '77px',
        28: '28px',
        42: '10.5rem',
        '296px': '296px',
        '232px': '232px',
        '388px': '388px',
        300: '300px',
        ellipse: '48px',
        'header-app-button': '150px',
        'subs-sel': '160px',
        mobile: '360px',
        'changes-block': '360px',
        'changes-block-m': '296px',
        'changes-block-l': '328px',
        'changes-block-xl': '90%',
        'messages-block': '300px',
        'steps-description': '320px',
        'steps-description-large': '480px',
        'steps-description-larger': '500px',
        'sandbox-menu': '500px',
        'color-box': '32px',
        'color-slider': '260px',
        'upload-photo': '76px',
        'device-cover': '118px',
        'device-photo': '118px',
        'device-photo-preview': '119px',
        'device-description': '220px',
        'device-chat-title': '120px',
        'orders-block': '1248px',
        'track-information': '280px',
        'verification-second-block': '500px',
        'verification-first-block': '300px',
        'input-preview': '348px',
        'verification-settings': '270px',
        'preview-avatar': '108px',
        'col-default-container': `calc(50% + calc(theme('width.mobile') / 2))`,
        '50vw': '50vw',
        '55vw': '55vw',
        '100vw': '100vw',
        'mobile-container-page-desc': '232px',
        'tablet-container-page-desc': '320px',
        'desktop-container-page-desc': '480px',
      },
      height: {
        28: '28px',
        77: '77px',
        80: '80px',
        90: '90px',
        92: '92px',
        95: '95px',
        105: '105px',
        114: '114px',
        141: '141px',
        '600p': '600px',
        '10v': '10vh',
        '20v': '20vh',
        '30v': '30vh',
        '40v': '40vh',
        '50v': '50vh',
        '54v': '54vh',
        '55v': '55vh',
        '56v': '56vh',
        '57v': '57vh',
        '60v': '60vh',
        '70v': '70vh',
        '80v': '80vh',
        '90v': '90vh',
        '100v': '100vh',
        ellipse: '48px',
        'device-height': '800px',
        'device-preview': '582px',
        'collapsed-device-preview': '459px',
        'sandbox-height': '650px',
        'builder-app': '900px',
        'changes-block-smaller': '288px',
        'changes-block-small': '310px',
        'changes-block': '338px',
        'changes-block-medium': '402px',
        'changes-block-large': '440px',
        'changes-block-larger': '548px',
        'color-box': '16px',
        'upload-photo': '76px',
        'device-cover': '102px',
        'device-photo': '120px',
        'device-photo-preview': '119px',
        'device-posts-height': '140px',
        'device-preview-second': '555px',
        'orders-block': '724px',
        'track-information': '78px',
        'preview-device': '800px',
        'verification-settings': '140px',
        'preview-avatar': '108px',
      },
      boxShadow: {
        sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        DEFAULT: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        '3xl': '0 35px 60px -15px rgba(0, 0, 0, 0.3)',
        inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
        none: 'none',
        'bp-nav': 'inset 0px -1px 0 #DCD6E7',
        'crm-nav': '0px 6px 10px rgba(0, 0, 0, 0.1)',
        'builder-device': '5px -1px 12.5px -5px rgba(27, 17,58, 0.15)',
      },
      fontSize: {
        xs: '.75rem', // 12px
        sm: '.875rem', // 14px
        tiny: '.875rem', // 14px
        base: '1rem', // 16px
        lg: '1.125rem', // 18px
        xl: '1.25rem', // 20px
        '2xl': '1.5rem', // 24px
        '3xl': '1.875rem', // 30px
        '4xl': '2.25rem', // 36px
        '5xl': '3rem', // 48px
        '6xl': '4rem', // 64px
        '7xl': '5rem', // 70px

        1: '1px',
        2: '2px',
        3: '3px',
        4: '4px',
        5: '5px',
        6: '6px',
        7: '7px',
        8: '8px',
        9: '9px',
        10: '10px',
        11: '11px',
        12: '12px',
        13: '13px',
        14: '14px',
        15: '15px',
        16: '16px',
        17: '17px',
        18: '18px',
        19: '19px',
        20: '20px',
        21: '21px',
        22: '22px',
        24: '24px',
        26: '26px',
        28: '28px',
        30: '30px',
        36: '36px',
        38: '38px',
        40: '40px',
      },
      borderWidth: {
        DEFAULT: '1px',
        0: '0',
        2: '2px',
        3: '3px',
        4: '4px',
        5: '5px',
        6: '6px',
        7: '7px',
        8: '8px',
      },
      minWidth: {
        0: '0',
        100:'100px',
        '1/4': '25%',
        '1/2': '50%',
        '3/4': '75%',
        full: '100%',
        'profile-sidebar': '250px',
        'business-block': '300px',
        'business-sidebar': '310px',
        modal: '640px',
        'light-menu': '320px',
        dashboard: '1440px',
        mobile: '360px',
        'mobile-input': '232px',
        'small-background': '300px',
        'checking-chats': '200px',
      },
      outline: {
        'theme-main': '1px solid #019DFF',
      },
      margin: {
        '1px': '1px',
        0.5: '0.15rem',
        1.5: '0.375rem',
        50: '50px',
        45: '45px',
        100: '100px',
        'bs-nav-inset': '-3px',
      },
      padding: {
        50: '50px',
        45: '45px',
        100: '100px',
      },
      backgroundSize: {
        auto: 'auto',
        cover: 'cover',
        contain: 'contain',
        'w-100': '100% auto',
        'h-100': 'auto 100%',
        sel: '10px',
      },
      backgroundImage: () => ({
        logo: 'url("../assets/images/crm/svg/logo.svg")',
        'dark-logo': 'url("../assets/images/crm/svg/dark-logo.svg")',
        'language-icon': 'url("../assets/images/crm/svg/lang-icon.svg")',
        'side-bar-icon': 'url("../assets/images/crm/svg/logout-icon.svg")',
        'dropdown-arrow': 'url("../assets/images/crm/svg/dropdown-arrow.svg")',
        'close-icon': 'url("../assets/images/crm/svg/close-icon.svg")',
        'dropdown-arrow-main': 'url("../assets/images/crm/svg/dropdown-arrow-main.svg")',
        message: 'url("../assets/images/crm/svg/message.svg")',
        'icon-user': 'url("../assets/images/crm/svg/1.svg")',
        'background-s': 'url("../assets/images/crm/png/S.png")',
        'supster-icon': 'url("../assets/images/crm/svg/supster.svg")',
        'back-arrow': 'url("../assets/images/crm/svg/back-arrow.svg")',
        'green-back-arrow': 'url("../assets/images/crm/svg/green-back-arrow.svg")',
        'danger-icon': 'url("../assets/images/crm/svg/danger.svg")',
        'pass-icon': 'url("../assets/images/crm/svg/pass-icon.svg")',
        'pass-icon-open': 'url("../assets/images/crm/svg/pass-icon-open.svg")',
        'register-icon': 'url("../assets/images/crm/svg/register-icon.svg")',
        'down-icon': 'url("../assets/images/crm/svg/arrow-down.png")',
        'smile-icon': 'url("../assets/images/crm/svg/smiler.png")',
        'colors-icon': 'url("../assets/images/crm/svg/colors-icon.png")',
        'images-icon': 'url("../assets/images/crm/svg/images-icon.png")',
        'music-icon': 'url("../assets/images/crm/svg/music-icon.png")',
        'settings-icon': 'url("../assets/images/crm/svg/setting.png")',
        'text-icon': 'url("../assets/images/crm/svg/text-icon.png")',
        'video-icon': 'url("../assets/images/crm/svg/video-icon.png")',
        'send-icon': 'url("../assets/images/crm/svg/send.svg")',
        'down-white': 'url("../assets/images/crm/svg/white-down.svg")',
        'loading-icon': 'url("../assets/images/crm/png/loading.png")',
        'vertical-dots': 'url("../assets/images/crm/png/vertical-dots.png")',
        ellipse: 'url("../assets/images/crm/svg/ellipse.svg")',
        'ellipse-check': 'url("../assets/images/crm/svg/ellipse-check.svg")',
        'back-to-login': 'url("../assets/images/crm/svg/back-to-login.svg")',
        'bp-home': 'url("../assets/images/crm/svg/bp-home.svg")',
        'bp-orders': 'url("../assets/images/crm/svg/bp-orders.svg")',
        'bp-buttons': 'url("../assets/images/crm/svg/bp-buttons.svg")',
        'bp-goods-and-services': 'url("../assets/images/crm/svg/bp-goods-and-services.svg")',
        'bp-referral': 'url("../assets/images/crm/svg/bp-referral.svg")',
        'bp-customers': 'url("../assets/images/crm/svg/bp-customers.svg")',
        'bp-auto-funnels': 'url("../assets/images/crm/svg/bp-auto-funnels.svg")',
        'bp-analytics': 'url("../assets/images/crm/svg/bp-analytics.svg")',
        'bp-special-offers': 'url("../assets/images/crm/svg/bp-special-offers.svg")',
        'bp-content': 'url("../assets/images/crm/svg/bp-content.svg")',
        'bp-sales-channels': 'url("../assets/images/crm/svg/bp-sales-channels.svg")',
        'bp-dropdown': 'url("../assets/images/crm/svg/bp-dropdown.svg")',
        'photo-icon': 'url("../assets/images/crm/svg/photo-icon.svg")',
        'video-icons': 'url("../assets/images/crm/svg/video-icon.svg")',
        'file-icon': 'url("../assets/images/crm/svg/file-icon.svg")',
        'poll-icon': 'url("../assets/images/crm/svg/poll-icon.svg")',
        'plus-icon': 'url("../assets/images/crm/svg/plus-icon.svg")',
        close: 'url("../assets/images/crm/svg/close.svg")',
        'sort-icon': 'url("../assets/images/crm/svg/sort.svg")',
        'minus-icon': 'url("../assets/images/crm/svg/minus.svg")',
        plus: 'url("../assets/images/crm/svg/plus.svg")',
        'load-icon': 'url("../assets/images/crm/png/loading-icon.png")',
        'home-icon': 'url("../assets/images/crm/svg/home-icon.svg")',
        'human-icon': 'url("../assets/images/crm/svg/human.png")',
        'menu-down': 'url("../assets/images/crm/svg/menu-down.svg")',
        'content-icon': 'url("../assets/images/crm/svg/content-icon.svg")',
        'close-red': 'url("../assets/images/crm/svg/red-colser.svg")',
        'green-horiz': 'url("../assets/images/crm/svg/green-horiz.svg")',
        'bluetooth-icon': 'url("../assets/images/crm/svg/bluetooth.svg")',
        'charge-icon': 'url("../assets/images/crm/svg/charge.svg")',
        'net-icon': 'url("../assets/images/crm/svg/net.svg")',
        'network-icon': 'url("../assets/images/crm/svg/network.svg")',
        'homes-icon': 'url("../assets/images/crm/svg/homes.svg")',
        'pages-icon': 'url("../assets/images/crm/svg/pages.svg")',
        'more-icon': 'url("../assets/images/crm/svg/more.svg")',
        's-icon': 'url("../assets/images/crm/svg/s.svg")',
        'p-icon': 'url("../assets/images/crm/svg/p.svg")',
        'delete-subs': 'url("../assets/images/crm/svg/delete-subs.svg")',
        'subs-sel': 'url("../assets/images/crm/svg/subs-sel.svg")',
        'pr-profile': 'url("../assets/images/crm/svg/pr-profile.svg")',
        'pr-cog': 'url("../assets/images/crm/svg/pr-cog.svg")',
        'pr-key': 'url("../assets/images/crm/svg/pr-key.svg")',
        'sorting-icon': 'url("../assets/images/crm/svg/sorting.svg")',
        'question-icon': 'url("../assets/images/crm/svg/question.svg")',
        'sup-icon': 'url("../assets/images/crm/svg/sup.svg")',
        'stepCheck-icon': 'url("../assets/images/crm/svg/setpCheck.svg")',
        'step1-icon': 'url("../assets/images/crm/svg/step1.svg")',
        'unchecked-icon': 'url("../assets/images/crm/svg/unchecked.svg")',
        '08purple-icon': 'url("../assets/images/crm/svg/08purple.svg")',
        'right-arrow-icon': 'url("../assets/images/crm/svg/right-arrow.svg")',
        'bottom-arrow-icon': 'url("../assets/images/crm/svg/bottom-arrow.svg")',
        'star-icon': 'url("../assets/images/crm/svg/star.svg")',
        'purple-arrow-icon': 'url("../assets/images/crm/svg/purple-arrow.svg")',
        'supLogo-icon': 'url("../assets/images/crm/svg/supLogo.svg")',
        check: 'url("../assets/images/crm/svg/check.svg")',
        uploadPhoto: 'url("../assets/images/crm/svg/ulpoadPhoto.svg")',
        'removePhoto-icon': 'url("../assets/images/crm/svg/removePhoto.svg")',
        'play-icon': 'url("../assets/images/crm/svg/play-video.png")',
        'modal-settings-icon': 'url("../assets/images/crm/svg/modal-settings.svg")',
        'delete-chat-icon': 'url("../assets/images/crm/svg/deleteChat.svg")',
        'mini-delete-icon': 'url("../assets/images/crm/svg/mini-delete.svg")',
        'showMenu-icon': 'url("../assets/images/crm/svg/showMenu.svg")',
        'minus-dark': 'url("../assets/images/crm/svg/minus-dark.svg")',
        'edit-icon': 'url("../assets/images/crm/svg/edit.svg")',
        'device-menu-icon': 'url("../assets/images/crm/svg/showMenu.svg")',
        'feed-button': 'url("../assets/images/crm/svg/feed-button.svg")',
        'chat-button': 'url("../assets/images/crm/svg/chat-button.svg")',
        'add-button': 'url("../assets/images/crm/svg/add-button.svg")',
        'search-button': 'url("../assets/images/crm/svg/search-button.svg")',
        'profile-button': 'url("../assets/images/crm/svg/profile-button.svg")',
        'add-post-button': 'url("../assets/images/crm/svg/add-post.svg")',
        more_down: 'url("../assets/images/crm/svg/more_down.svg")',
        'photo-device-icon': 'url("../assets/images/crm/svg/photo-device-icon.svg")',
        'post-device-icon': 'url("../assets/images/crm/svg/post-icon.svg")',
        'shop-device-icon': 'url("../assets/images/crm/svg/shop-icon.svg")',
        'video-device-icon': 'url("../assets/images/crm/svg/video-device-icon.svg")',
        'device-like-icon': 'url("../assets/images/crm/svg/device-like.svg")',
        // 'device-comment-icon': 'url("../assets/images/crm/svg/device-comment.svg")',
        'mobile-blur': 'url("../assets/images/crm/png/mobile-blur.png")',
        'supster-original-icon': 'url("../assets/images/crm/png/supster-original.svg")',
        'builder-post-stub': 'url("../assets/images/crm/svg/builder-post-stub.svg")',
        'builder-post-locked': 'url("../assets/images/crm/svg/builder-post-locked.svg")',
        'profile-avatar-stub': 'url("../assets/images/crm/svg/profile-stub-avatar.svg")',
        'avatar-message': 'url("../assets/images/crm/svg/avatar-message.svg")',
        'secreted-icon': 'url("../assets/images/crm/png/secreted.svg")',
        'chats-menu': 'url("../assets/images/crm/svg/chats-menu.svg")',
        'new-chats-menu': 'url("../assets/images/crm/svg/new-chats-menu.svg")',
        'new-channel-menu': 'url("../assets/images/crm/svg/new-channel-menu.svg")',
        'line-icon': 'url("../assets/images/crm/svg/line-icon.svg")',
        'union-icon': 'url("../assets/images/crm/svg/union.svg")',
        'pinned-icon': 'url("../assets/images/crm/svg/pinnded-icon.svg")',
        'go-down-icon': 'url("../assets/images/crm/svg/go-down.svg")',
        'seen-icon': 'url("../assets/images/crm/svg/seen-icon.svg")',
        'chat-menu-line': 'url("../assets/images/crm/svg/chat-menu-line.svg")',
        'circle-icon': 'url("../assets/images/crm/svg/circle.svg")',
        'private-chat-avatar': 'url("../assets/images/crm/svg/private-chat-avatar.svg")',
        'chat-back-icon': 'url("../assets/images/crm/svg/chat-back.svg")',
        'chat-header-avatar': 'url("../assets/images/crm/svg/chat-header-avatar.svg")',
        'chat-avatar': 'url("../assets/images/crm/svg/chat-avatar.svg")',
        'shat-pin-icon': 'url("../assets/images/crm/svg/shat-pin-icon.svg")',
        'message-avatar-one': 'url("../assets/images/crm/svg/message-avatar-one.svg")',
        'message-avatar-two': 'url("../assets/images/crm/svg/message-avatar-two.svg")',
        'message-avatar-tree': 'url("../assets/images/crm/svg/message-avatar-tree.svg")',
        'message-avatar-four': 'url("../assets/images/crm/svg/message-avatar-four.svg")',
        'business-menu-order': 'url("../assets/images/crm/svg/bussines-menu-order.svg")',
        'order-number-icon': 'url("../assets/images/crm/svg/order-number.svg")',
        'orders-pagination-back': 'url("../assets/images/crm/svg/orders-pagination-back.svg")',
        'orders-pagination-next': 'url("../assets/images/crm/svg/orders-pagination-next.svg")',
        'table-question-icon': 'url("../assets/images/crm/svg/table-question.svg")',
        'date-picker-icon': 'url("../assets/images/crm/svg/date-picker.svg")',
        'inform-arrow': 'url("../assets/images/crm/svg/inform-arrow.svg")',
        'profile-button-silver': 'url("../assets/images/crm/svg/profile-button-silver.svg")',
        'preview-avatar': 'url("../assets/images/crm/svg/preview-avatar.svg")',
        'chat-blue': 'url("../assets/images/crm/svg/chat-blue.svg")',
        'profile-silver': 'url("../assets/images/crm/svg/profile-silver.svg")',
        'inform-verification': 'url("../assets/images/crm/svg/inform-verification.svg")',
        'message-border': 'url("../assets/images/crm/svg/message-border.svg")',
        'black-supster': 'url("../assets/images/crm/svg/supster-preview-logo.svg")',
        'liner-black': 'url("../assets/images/crm/svg/liner-black.svg")',
        'fourg-black': 'url("../assets/images/crm/svg/fourg-black.svg")',
        'bluthoot-black': 'url("../assets/images/crm/svg/bluthoot-black.svg")',
        'charge-black': 'url("../assets/images/crm/svg/charge-black.svg")',
        'preview-avatar-verification':
          'url("../assets/images/crm/svg/preview-avatar-verification.svg")',
        'share-icon': 'url("../assets/images/crm/svg/share-icon.svg")',
        'profile-share': 'url("../assets/images/crm/svg/profile-share.svg")',
        'vector-icon': 'url("../assets/images/crm/svg/vector.svg")',
        'options-icon': 'url("../assets/images/crm/svg/options.svg")',
        settingsOne: 'url("../assets/images/crm/svg/settingsOne.svg")',
        settingsTwo: 'url("../assets/images/crm/svg/settingsTwo.svg")',
        settingsTree: 'url("../assets/images/crm/svg/settingsTree.svg")',
        settingsFour: 'url("../assets/images/crm/svg/settingsFour.svg")',
        settingsFive: 'url("../assets/images/crm/svg/settingsFive.svg")',
        settingsSix: 'url("../assets/images/crm/svg/settingsSix.svg")',
        settingsSeven: 'url("../assets/images/crm/svg/settingsSeven.svg")',
        settingsEight: 'url("../assets/images/crm/svg/settingsEight.svg")',
        settingsNine: 'url("../assets/images/crm/svg/settingsNine.svg")',
        photoOne: 'url("../assets/images/crm/svg/photoOne.svg")',
        photoTwo: 'url("../assets/images/crm/svg/photoTwo.svg")',
        photoThree: 'url("../assets/images/crm/svg/photoThree.svg")',
        photoFour: 'url("../assets/images/crm/svg/photoFour.svg")',
        photoFive: 'url("../assets/images/crm/svg/photoFive.svg")',
        'photo-lock': 'url("../assets/images/crm/svg/photo-lock.svg")',
        'affiliate-offers': 'url("../assets/images/crm/svg/affiliate-offers.svg")',
        offersQuestion: 'url("../assets/images/crm/svg/offersQuestion.svg")',
        'page-icon-one': 'url("../assets/images/crm/svg/page-icon-one.svg")',
        'page-icon-two': 'url("../assets/images/crm/svg/page-avatar-two.svg")',
        'russia-flag': 'url("../assets/images/crm/svg/russia-flag-icon.svg")',
        'affiliate-statistic': 'url("../assets/images/crm/svg/affiliate-statistic.svg")',
        'statistic-subscriptions-block':
          'url("../assets/images/crm/svg/statistic-subscriptions-block.svg")',
        'statistic-subscriptions-all':
          'url("../assets/images/crm/svg/statistic-subscriptions-all.svg")',
        'statistic-unfollow': 'url("../assets/images/crm/svg/statistic-unfollowl.svg")',
        'statistic-payment': 'url("../assets/images/crm/svg/statistic-payment.svg")',
        'delete-filter': 'url("../assets/images/crm/svg/delete-filter.svg")',
        'statistic-sort-icon': 'url("../assets/images/crm/svg/statistic-sort-icon.svg")',
        'question-icons': 'url("../assets/images/crm/svg/question-icons.svg")',
        'back-page': 'url("../assets/images/crm/svg/back-page.svg")',
        'show-page-icon': 'url("../assets/images/crm/svg/show-page-icon.svg")',
        'user-shown-icon': 'url("../assets/images/crm/svg/user-shown-icon.svg")',
        'sorting-icons': 'url("../assets/images/crm/svg/sorting-icon.svg")',
        'delete-sorting-icon': 'url("../assets/images/crm/svg/delete-sorting-icon.svg")',
        'checked-sources': 'url("../assets/images/crm/svg/checked-sources.svg")',
        'delete-chats-icon': 'url("../assets/images/crm/svg/delete-chats.svg")',
        'affiliate-news': 'url("../assets/images/crm/svg/affiliate-news.svg")',
        'social-instagram': 'url("../assets/images/crm/svg/instagram.svg")',
        'social-telegram': 'url("../assets/images/crm/svg/telegram.svg")',
        'social-facebook': 'url("../assets/images/crm/svg/facebook.svg")',
        'social-youtube': 'url("../assets/images/crm/svg/youtube.svg")',
        'social-vk': 'url("../assets/images/crm/svg/vk.svg")',
        'gradient-radial-instagram':
          'radial-gradient(143% 143% at 0.56% 109.71%, #FEC053 0%, #F2203E 32.73%, #B729A8 64.85%, #5342D6 100%)',
        'finances-icon': 'url("../assets/images/crm/svg/finances-icon.svg")',
        'finances-block-icon-one': 'url("../assets/images/crm/svg/finances-block-icon-one.svg")',
        'finances-block-icon-two': 'url("../assets/images/crm/svg/finances-block-icon-two.svg")',
        'finances-block-icon-three':
          'url("../assets/images/crm/svg/finances-block-icon-three.svg")',
        'finances-block-icon-four': 'url("../assets/images/crm/svg/finances-block-icon-four.svg")',
        'affiliate-streams': 'url("../assets/images/crm/svg/affiliate-streams.svg")',
        'device-background': '-webkit-linear-gradient(180deg, #f4f2f7 50%, #271460 50%)',
        'device-background-for-view': '-webkit-linear-gradient(180deg, #f4f2f7 70%, #271460 30%)',
        'device-background-half': '-webkit-linear-gradient(180deg, #f4f2f7 90%, #271460 10%)',
        'menu-bevel': 'url("../assets/images/crm/svg/menu-bevel.svg")',
        'menu-bevel-circle': 'url("../assets/images/crm/svg/menu-bevel-circle.svg")',
        'eye': 'url("../assets/images/crm/svg/eye.svg")',
        'eye-crm2': 'url("../assets/images/crm/svg/eye-crm2.svg")',
        'arrow-top': 'url("../assets/images/crm/svg/arrow-top.svg")'
      }),
      lineHeight: {
        '4.5': '1.125rem', // 18px
        '5.5': '1.375rem', // 22px
        '6.5': '1.675rem', // 26px
        '9.75': '2.375rem' // 40px
      },
      zIndex: {
        0: 'inherit',
        '55': '55',
        '60': '60',
        '70': '70'
      },
      transitionTimingFunction: {
        'main-menu-transition-tf': 'cubic-bezier(.36,.18,.58,.99)'
      }
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    plugin(({ addVariant, e }) => {
      addVariant('dark', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => `.dark .${e(`dark${separator}${className}`)}`)
      })
      addVariant('dark-hover', ({ modifySelectors, separator }) => {
        modifySelectors(
          ({ className }) => `.dark .${e(`dark${separator}hover${separator}${className}`)}:hover`
        )
      })
    }),
  ],
}
